import { Stack, Theme, Typography, useMediaQuery } from "@mui/material";
import { GeneralContext } from "Context";
import { useContext, useEffect } from "react";

interface CustomProps {
  show: boolean;
  announcement: string;
  backgroundColor: string;
  textColor?: string;
}

const AnnouncementBanner = (props: CustomProps) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  return props.show ? (
    <div role="region" aria-label="Announcement">
      <Stack
        sx={{
          position: "fixed",
          width: "100%",
          height: isMobile ? "45px" : "25px",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
          backgroundColor: props.backgroundColor,
          py: 0.5,
        }}
      >
        <Typography
          color={props.textColor ?? "white"}
          variant="subtitle2"
          textAlign="center"
          fontSize={"0.8rem"}
          sx={{ px: 2 }}
        >
          {props.announcement}
        </Typography>
      </Stack>
    </div>
  ) : null;
};

export default AnnouncementBanner;
